// components/common/AppSpinner.tsx
import React from "react";
import { Spin } from "antd";

type AppSpinnerProps = {
  size?: "small" | "default" | "large";
  tip?: string;                 // 로딩 문구
  spinning?: boolean;           // 기본 true
  className?: string;
  fullscreen?: boolean;         // 전체 화면 중앙 정렬
};

const AppSpinner: React.FC<AppSpinnerProps> = ({
  size = "default",
  tip,
  spinning = true,
  className,
  fullscreen = false,
}) => {
  if (fullscreen) {
    return (
      <div className={`app-spinner-full ${className ?? ""}`}>
        <Spin size={size} tip={tip} spinning={spinning} />
      </div>
    );
  }

  return <Spin size={size} tip={tip} spinning={spinning} className={className} />;
};

export default AppSpinner;
